import React, { useState, useEffect, useCallback, memo } from 'react'
import Search from '../search'
import MaterialTable from '../material-table'
import { Tooltip, Modal, Popover, Button, message, Radio, Tabs, Alert } from 'antd'
import { ExclamationCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { getQuery } from '@/common/utils'
import { addDomain } from '@/env'
import useSkuTree from '@/hooks/useSkuTree'
import useStayReport from '@/hooks/useStayReport'
import { getInviteMaterialList } from '@/apis/invite'
import MaterialTables from '../spu-material-table'
import SwitchTab from '../../../pages/activity-manage/merchants/detail/components/my-product-list/components/SwitchTab'
import {
  getMaterialList,
  saveMaterial,
  createSkuMaterialPic,
  getGoodsGuide,
  batchUpdateSkuMaterials,
  querySpuForPageList,
} from '@/apis/skuMaterials'
import { Status } from '../material-table/components/columns/type'
import { pickBy, identity, cloneDeep } from 'lodash'
import { showOverTime } from '../utils'
import './index.less'

const { confirm } = Modal
const pager = {
  current: 1,
  total: 1,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: [10, 20, 50],
}

export default memo(function (props) {
  useStayReport()
  const ruleType = props.ruleType
  const { businessNewStep, spuFlow, totalApply } = props
  const { categories } = useSkuTree()
  const planCode = getQuery('planCode')
  const [memoDataSource, setMemoDataSource] = useState([])
  const [dataSource, setDatasource] = useState()
  const [dataSpuSource, setDataspusource] = useState()
  const [paginations, setPaginations] = useState(pager)
  const [params, setParams] = useState({
    skuQueryType: 1,
  })
  const [spu, setSpu] = useState([
    // {
    //   code: 'skuName',
    //   name: '商品名称',
    //   placeholder: '请输入',
    //   width: 200,
    //   isVisiable: true,
    //   dataType: 1,
    // },
    {
      code: 'goods',
      name: '商品ID',
      placeholder: '请输入',
      width: 265,
      isVisiable: true,
      dataType: 2,
      initialValue: { goodsType: '1' },
    },
    // {
    //   code: 'categoryThirdIds',
    //   name: '类目',
    //   placeholder: '请输入',
    //   width: 250,
    //   dataType: 3,
    //   isVisiable: true,
    //   options: categories,
    // },
  ])
  const [loading, setLoading] = useState(false)
  const [haveData, setHaveData] = useState(false)
  const [visible, setVisible] = useState(false)
  const [titleShow, setTitleShow] = useState(false)
  const [pagination, setPagination] = useState(pager)
  const [items, setItems] = useState([
    // {
    //   code: 'skuQueryType',
    //   name: '商品类型',
    //   placeholder: '请选择商品类型',
    //   width: 200,
    //   dataType: 5,
    //   initialValue: '1',
    //   options: [
    //     {
    //       label: '全部商品',
    //       value: '0',
    //     },
    //     {
    //       label: '全部主推品',
    //       value: '1',
    //     },
    //     {
    //       label: '活动主推品',
    //       value: '2',
    //     },
    //     {
    //       label: '行业主推品',
    //       value: '3',
    //     },
    //   ],
    // },
    {
      code: 'mainPushFlag',
      name: '仅看主推品',
      placeholder: '',
      width: 120,
      dataType: 4,
      initialValue: true,
    },
    {
      code: 'skuName',
      name: '商品名称',
      placeholder: '请输入商品名称',
      width: 200,
      dataType: 1,
    },
    {
      code: 'goods',
      name: '商品ID',
      placeholder: '请输入商品ID',
      width: 265,
      dataType: 2,
      initialValue: { goodsType: '2' },
    },
    {
      code: 'categoryThirdIds',
      name: '类目',
      placeholder: '',
      width: 250,
      dataType: 3,
      options: categories,
    },
    {
      code: 'roleGroupId',
      name: '主推品类型',
      placeholder: '请选择主推品类型',
      width: 160,
      dataType: 5,
      options: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '尖货',
          value: '-1',
          clstag: 'yx_materia_zhutui_select_1637301723127|2',
        },
        {
          label: '爆品',
          value: '342',
          clstag: 'yx_materia_zhutui_select_1637301723127|1',
        },
        // {
        //   label: '品质品',
        //   value: '22633',
        //   clstag: 'yx_materia_zhutui_select_1637301723127|3',
        // },
      ],
    },
    {
      code: 'skuMaterialStatus',
      name: '素材状态',
      placeholder: '请选择状态',
      width: 200,
      style: { width: 130 },
      dataType: 5,
      options: [
        {
          label: '未完善',
          value: '1',
        },
        {
          label: '审核通过',
          value: '2',
        },
        {
          label: '审核驳回',
          value: '3',
        },
        {
          label: '审核中',
          value: '4',
        },
        {
          label: '机审通过',
          value: '5',
        },
      ],
    },
  ])

  useEffect(() => {
    if (ruleType == 'newInvite') {
      setItems([
        {
          code: 'skuMaterialStatus',
          name: '完善状态',
          placeholder: '请选择状态',
          width: 180,
          dataType: 5,
          isVisiable: true,
          options: [
            {
              label: '未完善',
              value: '1',
            },
            {
              label: '审核通过',
              value: '2',
            },
            {
              label: '审核驳回',
              value: '3',
            },
            {
              label: '审核中',
              value: '4',
            },
          ],
        },
        {
          code: 'skuName',
          name: '商品名称',
          placeholder: '请输入商品名称',
          width: 180,
          isVisiable: true,
          dataType: 1,
        },
        {
          code: 'skuId',
          name: 'sku',
          placeholder: '请输入商品ID',
          width: 160,
          isVisiable: true,
          dataType: 1,
        },
        {
          code: 'categoryThirdIds',
          name: '所属类目',
          placeholder: '',
          width: 225,
          dataType: 3,
          isVisiable: false,
          options: categories,
        },
      ])
    }
  }, [ruleType])
  const initTitleTip = ({ show, never }) => {
    setTitleShow(show)
    localStorage.setItem(
      'titleTip',
      JSON.stringify({
        never,
        time: new Date().getTime(),
      })
    )
  }

  const getTabData = () => [
    {
      localName: <span>SKU</span>,
      name: <span style={{ display: 'inline-block' }}>SKU</span>,
      key: 'sku',
      left: 3,
      index: 1,
    },
    {
      localName: <span>SPU</span>,
      name: <span style={{ display: 'inline-block' }}>SPU</span>,
      key: 'spu',
      left: 105,
      index: 2,
    },
  ]
  const [switchTab, setSwitchTab] = useState(getTabData()[0])
  const [activeKey, setActiveKey] = useState('sku')

  const onChangeSwitch = (e) => {
    setActiveKey(e)
    if (e === 'sku') {
      setSwitchTab(getTabData()[0])
    } else {
      setSwitchTab(getTabData()[1])
    }
  }

  const content = () => {
    return (
      <div style={{ width: 424 }}>
        <div style={{ fontWeight: 500, fontSize: 16 }}>营销短标题字数限制调整</div>
        <div style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.65)', marginTop: 12 }}>
          为保障前台展示效果和购物体验，
          <span style={{ color: 'rgba(242, 39, 12, 1)' }}>营销短标题限制为4-8个汉字（8-16个字符）</span>
          ，系统已为您自动调整短标题，请确认后保存。若仍有未覆盖到的，请您重新填写～
        </div>
        <div style={{ textAlign: 'right', margin: '12px 0 8px 0' }}>
          <Button
            style={{ marginRight: 8 }}
            onClick={() =>
              initTitleTip({
                show: false,
                never: true,
              })
            }
          >
            不再提醒
          </Button>
          <Button type="primary" onClick={() => setTitleShow(false)}>
            我知道了
          </Button>
        </div>
      </div>
    )
  }

  // 三天提示短标题
  useEffect(() => {
    const range = 86400000 * 3 // 3 天
    const getTipMsg = localStorage.getItem('titleTip')
    if (getTipMsg) {
      const msg = JSON.parse(getTipMsg)
      if (new Date().getTime() - msg.time > range) {
        setTitleShow(true)
      }
      if (msg.never) {
        setTitleShow(false)
      }
      msg.time = new Date().getTime()
      localStorage.setItem('titleTip', JSON.stringify(msg))
    } else {
      initTitleTip({
        show: true,
        never: false,
      })
    }
  }, [])

  useEffect(() => {
    if (categories && categories.length && activeKey === 'sku') {
      const item = items.find((item) => item.code === 'categoryThirdIds')
      if (item) {
        item.options = categories
      }
      setItems([...items])
    }
  }, [categories, activeKey])

  useEffect(() => {
    if (categories && categories.length && activeKey === 'spu') {
      const spuItem = spu.find((item) => item.code === 'categoryThirdIds')
      if (spuItem) {
        spuItem.options = categories
      }
      setSpu([...spu])
    }
  }, [categories, activeKey])

  // 获取填充逻辑
  const getCreteaPic = useCallback(
    async (list = []) => {
      const skuIdList = list.filter((item) => !item.smartPicWhite || !item.smartPicTransparent).map((i) => i.skuId)
      if (skuIdList.length) {
        try {
          setLoading(true)
          const { data: result } = await createSkuMaterialPic({ skuIdList })
          setLoading(false)
          list.forEach((item) => {
            if (!item.smartPicWhite && result[item.skuId].smartPicWhite) {
              item.smartPicWhite = {
                value: result[item.skuId].smartPicWhite,
                flag: true,
              }
            }
            if (!item.smartPicTransparent && result[item.skuId].smartPicTransparent) {
              item.smartPicTransparent = {
                value: result[item.skuId].smartPicTransparent,
                flag: true,
              }
            }
          })
        } catch (error) {}
      }
      setMemoDataSource(cloneDeep(list))
      setDatasource([...list])
      return list
    },
    [items]
  )

  // 获取接口
  const getList = useCallback(
    async (extraParams = {}, page) => {
      setDatasource([])
      let fn = getMaterialList
      const activityIdInfo = {}
      if (ruleType == 'newInvite') {
        fn = getInviteMaterialList
        activityIdInfo.activityId = props.activityId
        Reflect.deleteProperty(extraParams, 'skuQueryType')
      }
      if (businessNewStep) {
        Reflect.deleteProperty(extraParams, 'mainPushFlag')
        Reflect.deleteProperty(extraParams, 'skuQueryType')
      }
      const { data: res } = await fn(
        Object.assign(
          {},
          {
            page: page.current,
            pageSize: page.pageSize,
            planCode,
            // applyStatus: 1,
            applyStatusCode: 'APPLIED',
          },
          pickBy(extraParams, identity),
          activityIdInfo
        )
      )
      setLoading(false)
      if (res && res.items && res.items.length) {
        res.items.forEach((i) => {
          if (i.skuMaterialStatus === Status['未完善'] || i.skuMaterialStatus === Status['审核失败']) {
            i.editorStatus = true
          } else {
            i.editorStatus = false
          }
        })
      }
      pagination.current = res.page
      pagination.pageSize = res.pageSize
      pagination.total = res.totalCount
      setPagination({ ...pagination })
      setDatasource(res.items)
      getCreteaPic(res.items || [])
      // setDatasource(await getCreteaPic(res.items || []))
    },
    [items]
  )

  // 获取spu信息接口
  const getSpuList = useCallback(
    async (extraParams = {}, page) => {
      let fn = querySpuForPageList
      const activityIdInfo = {}
      if (ruleType == 'newInvite') {
        fn = getInviteMaterialList
        activityIdInfo.activityId = props.activityId
      }
      if (businessNewStep) {
        Reflect.deleteProperty(extraParams, 'mainPushFlag')
      }
      const response = await fn(
        Object.assign(
          {},
          {
            currentPage: page.current || 1,
            pageSize: page.pageSize || 10,
            planCode,
            applyStatus: 3,
            goodsType: 1,
            // applyStatus: 1,
          },
          pickBy(extraParams, identity),
          activityIdInfo
        )
      )
      const res = response.data
      if (res.items && res.items.length) {
        res.items.forEach((i) => {
          if (i.skuMaterialStatus === Status['未完善'] || i.skuMaterialStatus === Status['审核失败']) {
            i.editorStatus = true
          } else {
            i.editorStatus = false
          }
        })
      }
      setPaginations({ current: page.current, pageSize: page.pageSize, total: res.totalCount })
      setDataspusource(res.items)
      // getCreteaPic(res.items || [])
      // setDatasource(await getCreteaPic(res.items || []))
    },
    [items]
  )

  // 翻页
  const onChange = (current, pageSize) => {
    getList(Object.assign(params, { mainPushFlag: params.mainPushFlag ? 1 : 0 }), {
      current: current,
      pageSize: pageSize,
    })
  }

  // 翻页
  const onPageChange = (current, pageSize) => {
    getSpuList(params, { current, pageSize })
  }

  // 默认查询是否有数据
  useEffect(() => {
    async function fetchData() {
      let fn = getMaterialList
      const activityIdInfo = {}
      if (ruleType == 'newInvite') {
        fn = getInviteMaterialList
        activityIdInfo.activityId = props.activityId
      }
      const { data: res } = await fn(
        Object.assign(
          {},
          {
            page: 1,
            pageSize: 10,
            planCode,
            applyStatus: 1,
          },
          activityIdInfo
        )
      )
      if (res) {
        setHaveData(Boolean(res.totalCount))
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (ruleType !== 'newInvite') {
      // getGoodsGuide({ planCode, type: 1 }).then((res) => {
      //   if (res.ret === '0') {
      //     confirm({
      //       title: '重要通知',
      //       icon: <ExclamationCircleOutlined />,
      //       content: '请务必完善主推商品素材，您将有机会更多曝光机会和转化',
      //       okType: 'danger',
      //       cancelButtonProps: {
      //         className: 'notice-material-delete',
      //       },
      //       okText: '我知道了',
      //       className: 'notice-material',
      //       onOk() {
      //         setVisible(true)
      //       },
      //     })
      //   }
      // })
    }
    getList(params, pager)
    getSpuList(params, { current: 1, pageSize: 10 })
  }, [])

  // 查询
  const onSearch = (e) => {
    e.goodsType = Number(e.goods.goodsType)
    e.goodsId = e.goods.goodsId
    delete e['goods']
    setParams({ ...e })
    getList(Object.assign(pickBy(e, identity), { mainPushFlag: e.mainPushFlag ? 1 : 0 }), {
      current: 1,
      pageSize: pagination.pageSize,
    })
  }

  // 查询
  const onSearchSpu = (e) => {
    e.goodsType = Number(e.goods.goodsType)
    e.goodsId = e.goods.goodsId
    delete e['goods']
    setParams({ ...e })
    getSpuList(Object.assign(pickBy(e, identity), { mainPushFlag: e.mainPushFlag ? 1 : 0 }), {
      current: 1,
      pageSize: paginations.pageSize,
    })
  }

  // 自定义表头(强制一样)
  let sucHeaderList = [
    {
      code: 'skuId',
      dataType: 4,
      displayType: 0,
      id: 171510042,
      width: 400,
      itemOptionVOList: [],
      itemRuleVOList: [
        { errorTip: '该项为必填项', ruleCode: 'required', ruleType: 10, ruleValue: 'false' },
        { errorTip: 'SKU无效或已报名', ruleCode: 'sku', ruleType: 20, ruleValue: 'true' },
      ],
      name: '商品SKU',
      remark: '',
      seq: 1,
      subFormItemVOList: [],
      systemDefault: 0,
      usable: 1,
    },
    {
      code: 'picUrl',
      dataType: 2,
      displayType: 0,
      id: 'smartPicTransparent',
      itemOptionVOList: [],
      formItem: true,
      width: 140,
      titleInfo: (
        <div>
          要求：800px*800px，72分辨率，PNG格式，小于1M；透明图商品主体要与主图一致，不可扣图破损，不可扣图不干净，不可有影子，不可出现LOGO，除商品以外所有文字促销水印信息，图片需要满画布产品居中展示，左右或者上下顶边。如违规会被驳回，请确认无误后保存！【透明图规范】(
          <a href="https://helpcenter.jd.com/vender/issue/44325.html" target="_blank" rel="noopener noreferrer">
            https://helpcenter.jd.com/vender/issue/44325.html
          </a>
          )
        </div>
      ),
      itemRuleVOList: [
        // { errorTip: '该项为必填项', ruleCode: 'required', ruleType: 10, ruleValue: 'true' },
        { errorTip: '不满足图片宽', ruleCode: 'imgWidth', ruleType: 10, ruleValue: '800' },
        { errorTip: '不满足图片高', ruleCode: 'imgHeight', ruleType: 10, ruleValue: '800' },
        { errorTip: '超出图片大小', ruleCode: 'imgSize', ruleType: 10, ruleValue: '1024' },
        { errorTip: '图片格式不符合要求', ruleCode: 'imgExtension', ruleType: 10, ruleValue: 'png' },
      ],
      name: '商品透底图',
      titleExtra: (
        <Tooltip placement="top" title="透底图主要应用于核心频道、部分活动会场的商品资源位露出，请及时完善素材哦！">
          <ExclamationCircleFilled style={{ marginLeft: 4, color: 'orange' }} />
        </Tooltip>
      ),
      remark: '',
      seq: 4,
      subFormItemVOList: [],
      systemDefault: 1,
      usable: 1,
    },
    {
      code: 'smartPicWhite',
      dataType: 2,
      displayType: 0,
      id: 'smartPicWhite',
      itemOptionVOList: [],
      formItem: true,
      width: 150,
      titleInfo: (
        <div>
          要求：800px*800px，72分辨率，JPG格式，小于2M；白底图需为纯白背景，商品需居中展示，不可破损，不可展示细节图，尽量铺满画布；禁止出现LOGO、边框、除商品本身以外的所有文字促销水印信息。如违规会被驳回，请确认无误后保存！【白底图规范】(
          <a href="https://helpcenter.jd.com/vender/issue/44422.html" target="_blank" rel="noopener noreferrer">
            https://helpcenter.jd.com/vender/issue/44422.html
          </a>
          )
        </div>
      ),
      itemRuleVOList: [
        // { errorTip: '该项为必填项', ruleCode: 'required', ruleType: 10, ruleValue: 'true' },
        { errorTip: '不满足图片宽', ruleCode: 'imgWidth', ruleType: 10, ruleValue: '800' },
        { errorTip: '不满足图片高', ruleCode: 'imgHeight', ruleType: 10, ruleValue: '800' },
        { errorTip: '超出图片大小', ruleCode: 'imgSize', ruleType: 10, ruleValue: '2048' },
        { errorTip: '图片格式不符合要求', ruleCode: 'imgExtension', ruleType: 10, ruleValue: 'jpg,jpeg' },
      ],
      name: '商品白底图',
      titleExtra: (
        <Tooltip placement="top" title="白底图主要应用于首页、各类活动会场的商品资源位露出，请及时完善素材哦！">
          <ExclamationCircleFilled style={{ marginLeft: 4, color: 'orange' }} />
        </Tooltip>
      ),
      remark: '',
      seq: 4,
      subFormItemVOList: [],
      systemDefault: 1,
      usable: 1,
    },
    {
      code: 'smartContentSell',
      dataType: 1,
      displayType: 0,
      id: 'smartContentSell',
      itemOptionVOList: [],
      formItem: true,
      titleInfo: (
        <div>
          最少填2个卖点，单个卖点最少3个字，最多7个字。【营销卖点规范】(
          <a href="https://helpcenter.jd.com/vender/issue/44406.html" target="_blank" rel="noopener noreferrer">
            https://helpcenter.jd.com/vender/issue/44406.html
          </a>
          )
        </div>
      ),
      itemRuleVOList: [
        // { errorTip: '该项为必填项', ruleCode: 'required', ruleType: 10, ruleValue: 'true' },
        { errorTip: '超出最大长度', ruleCode: 'maxLength', ruleType: 10, ruleValue: '7' },
        { errorTip: '小于最小长度', ruleCode: 'minLength', ruleType: 10, ruleValue: '3' },
        { errorTip: '请填写纯数字', ruleCode: 'intTextOpen', ruleType: 20, ruleValue: '0' },
      ],
      name: '营销卖点',
      titleExtra: (
        <Tooltip placement="top" title="主要用于各类会场中商品坑位的角标处，通过显示商品卖点，激发消费者购买欲望。">
          <ExclamationCircleFilled style={{ marginLeft: 4, color: 'orange' }} />
        </Tooltip>
      ),
      remark: '',
      seq: 3,
      subFormItemVOList: [],
      systemDefault: 1,
      usable: 1,
    },
    {
      code: 'smartContentSortTitle',
      dataType: 1,
      displayType: 0,
      id: 'smartContentSortTitle',
      itemOptionVOList: [],
      formItem: true,
      titleInfo: (
        <div>
          内容要求最少4个汉字，最多8个汉字。【营销短标题规范】(
          <a href="https://helpcenter.jd.com/vender/issue/44406.html" target="_blank" rel="noopener noreferrer">
            https://helpcenter.jd.com/vender/issue/44406.html
          </a>
          )
        </div>
      ),
      itemRuleVOList: [
        // { errorTip: '该项为必填项', ruleCode: 'required', ruleType: 10, ruleValue: 'true' },
        { errorTip: '超出最大长度', ruleCode: 'maxLength', ruleType: 10, ruleValue: '8' },
        { errorTip: '小于最小长度', ruleCode: 'minLength', ruleType: 10, ruleValue: '4' },
        { errorTip: '请填写纯数字', ruleCode: 'intTextOpen', ruleType: 20, ruleValue: '0' },
      ],
      name: '营销短标题',
      nameJsx: (
        <span>营销短标题</span>
        // <Popover content={content()} trigger="hover" visible={titleShow}>
        //   <span>营销短标题</span>
        // </Popover>
      ),
      titleExtra: (
        <Tooltip
          // visible={visible}
          // onVisibleChange={(e) => setVisible(e)}
          placement="top"
          title="主要应用于各类活动会场内的商品楼层，使用户通过“短标题”快速了解商品信息。"
        >
          <ExclamationCircleFilled style={{ marginLeft: 4, color: 'orange' }} />
        </Tooltip>
      ),
      remark: '',
      seq: 3,
      subFormItemVOList: [],
      systemDefault: 1,
      usable: 1,
    },
    {
      code: 'skuMaterialStatus',
      id: 'skuMaterialStatus',
      width: 120,
      titleExtra: (
        <Tooltip
          placement="top"
          title="请注意，机审通过状态不等同于审核通过，后续会进一步人工审核，请持续关注审核进度。"
        >
          <ExclamationCircleOutlined style={{ marginLeft: 4, color: 'rgba(0, 0, 0, 0.45)' }} />
        </Tooltip>
      ),
      name: '素材状态',
      fixed: 'right',
      itemRuleVOList: [],
    },
    {
      code: 'opt',
      id: 'opt',
      width: 120,
      name: '操作',
      fixed: 'right',
      itemRuleVOList: [],
    },
  ]

  if (ruleType === 'newInvite') {
    const actInfo = props.actInfo
    const status = showOverTime(actInfo.endTimeStr).cutOffStatus
    sucHeaderList = sucHeaderList.filter((item) => {
      if (item.id === 'smartContentSortTitle') return !!actInfo.enableSortTitle
      if (item.id === 'smartContentSell') return !!actInfo.enableContentSell
      if (item.id === 'smartPicTransparent') return !!actInfo.enablePicTransparent
      if (item.id === 'smartPicWhite') return !!actInfo.enablePicWhite
      if (item.id === 'opt' && status === 0) return false
      return true
    })
  }

  if (businessNewStep) {
    const optColumn = sucHeaderList.find((item) => item.code === 'opt')
    const skuMaterialColumn = sucHeaderList.find((item) => item.code === 'skuMaterialStatus')
    sucHeaderList = sucHeaderList.filter((item) => !['opt', 'skuMaterialStatus'].includes(item.code))
    sucHeaderList = [
      ...sucHeaderList,
      ...[
        // {
        //   code: 'promoStatus',
        //   id: 'promoStatus',
        //   width: 120,
        //   name: '促销状态',
        //   itemRuleVOList: [],
        //   render(text) {
        //     const promoStatusMap = {
        //       1: '未建立',
        //       2: '建立失败',
        //       3: '审核中',
        //       4: '建立成功',
        //       5: '已删除',
        //       6: '促销系统驳回',
        //     }
        //     return promoStatusMap[text] || '-'
        //   },
        // },
        {
          code: 'applyStatus',
          id: 'applyStatus',
          width: 120,
          name: totalApply ? '参与状态' : '报名状态',
          itemRuleVOList: [],
          render(text) {
            const applyStatusMap = {
              0: '未报名',
              1: '已报名',
              2: '已退出活动',
            }
            const totalApplyStatusMap = {
              0: '未参与',
              1: '已参与',
              2: '已退出',
            }
            return (totalApply ? totalApplyStatusMap[text] : applyStatusMap[text]) || '-'
          },
        },
        skuMaterialColumn,
        optColumn,
      ],
    ]
  }

  const save = ({ postData, record, changeStatus }) => {
    let noShowData = {}
    if (ruleType == 'newInvite') {
      const currentItem = memoDataSource.find((item) => item.skuId === record.skuId)
      const allKeys = [
        'smartContentSell',
        'smartContentSell2',
        'smartContentSell3',
        'smartContentSortTitle',
        'smartPicTransparent',
        'smartPicWhite',
      ]
      allKeys.forEach((key) => {
        if (!postData.hasOwnProperty(key) && currentItem.hasOwnProperty(key)) {
          const value = currentItem[key] && currentItem[key].value
          noShowData = { ...noShowData, [key]: value }
        }
      })
    }
    saveMaterial([{ ...postData, planCode, ...noShowData }]).then((res) => {
      if (res && res.ret == 0) {
        message.success('保存成功')
        changeStatus(res.data.items)
      } else {
        changeStatus(false)
        message.error((res || {}).msg || '保存失败')
      }
    })
  }

  const batchSave = (e, editMutApplyRes) => {
    // 配合后端逻辑修复，增加planCode入参
    const paramsObj = (e || []).map((item) => Object.assign(item, { planCode }))
    saveMaterial(paramsObj).then((res) => {
      if (res && res.ret == 0) {
        message.success('批量保存成功')
        editMutApplyRes(res.data.items)
      } else {
        editMutApplyRes(false)
        message.error((res || {}).msg || '批量保存失败')
      }
    })
  }
  useEffect(() => {
    if (businessNewStep) {
      let columns = items.filter((item) => !['mainPushFlag', 'roleGroupId'].includes(item.code))
      columns = [
        ...columns,
        ...[
          {
            code: 'activityStatusCode',
            name: totalApply ? '参与状态' : '报名状态',
            placeholder: '请选择状态',
            width: 200,
            style: { width: 130 },
            dataType: 5,
            isVisiable: true,
            options: [
              {
                label: totalApply ? '已参与' : '已报名',
                value: 'APPLIED',
              },
              {
                label: totalApply ? '已退出' : '已退出活动',
                value: 'QUITED',
              },
            ],
          },
          {
            code: 'promoStatus',
            name: '促销状态',
            placeholder: '请选择状态',
            width: 200,
            style: { width: 130 },
            dataType: 5,
            isVisiable: true,
            options: [
              {
                label: '未建立',
                value: '1',
              },
              {
                label: '建立失败',
                value: '2',
              },
              {
                label: '审核中',
                value: '3',
              },
              {
                label: '建立成功',
                value: '4',
              },
              {
                label: '已删除',
                value: '5',
              },
              {
                label: '促销系统驳回',
                value: '6',
              },
            ],
          },
        ],
      ]
      setItems(columns)
    }
  }, [businessNewStep])

  const batchSaves = (e, editMutApplyReSpu) => {
    // 配合后端逻辑修复，增加planCode入参
    const paramsObj = (e || []).map((item) => Object.assign(item, { planCode }))
    const updateType = 1
    batchUpdateSkuMaterials({ list: paramsObj, planCode, updateType })
      .then((res) => {
        message.success('批量保存中，素材状态请在5分钟后刷新进行查看')
        editMutApplyReSpu(res)
      })
      .catch((e) => {
        editMutApplyReSpu(false)
      })
  }

  const getAlertMsg = () => {
    let alertMsg = undefined
    if (businessNewStep) {
      alertMsg = (
        <div>
          {totalApply ? '参与打标后，' : '报名完成后，'}
          如果有待完善的素材，请尽快完善素材。素材维护并审核通过后可进入素材库，后续活动无需再进行维护。
          <br />
          已完善的请关注素材审核状态，商品素材预计5个工作日内审核完毕，若5个工作日仍未完成审核或对审核结果存在疑问，可进入咚咚群反馈，群号1：1020356819
          群号2：1023793577 群号3：1023793615。
        </div>
      )
    } else {
      if (haveData) {
        alertMsg =
          '此部分默认展示建议优先维护的主推商品，请您务必完善以下商品素材，以免影响主推商品被系统选中上场，如无商品展示，请关闭左上角主推品筛选功能后进行素材维护。素材维护并审核通过后可进入素材库，后续活动都无需再次进行维护。'
      }
    }
    return alertMsg
  }

  return (
    <div>
      {ruleType != 'newInvite' && (
        <Alert message={getAlertMsg()} type="warning" showIcon closable style={{ marginBottom: 16 }} />
      )}
      {activeKey === 'sku' && (
        <MaterialTable
          Search={Search}
          spuFlow={spuFlow}
          searchMaxWidth={businessNewStep ? 1100 : null}
          needBatchSave={ruleType != 'newInvite'}
          uploadImgUrl={addDomain('/file/uploadFile')}
          sucHeaderList={sucHeaderList}
          type="erp"
          contorlItems={items}
          dataSource={dataSource}
          pagination={pagination}
          onChange={onChange}
          loading={loading}
          onSearch={onSearch}
          save={save}
          batchSave={batchSave}
          isProd={process.env.API_ENV === 'production'}
          SwitchTab={<SwitchTab tab={switchTab} getTabData={getTabData} onChange={onChangeSwitch} showNum={false} />}
        />
      )}
      {activeKey === 'spu' && (
        <MaterialTables
          spuFlow={spuFlow}
          Search={Search}
          searchMaxWidth={businessNewStep ? 1100 : null}
          needBatchSave={ruleType != 'newInvite'}
          uploadImgUrl={addDomain('/file/uploadFile')}
          sucHeaderList={sucHeaderList}
          type="erp"
          contorlItems={spu}
          dataSource={dataSource}
          dataSpuSource={dataSpuSource}
          pagination={pagination}
          onChange={onChange}
          loading={loading}
          onSearchs={onSearchSpu}
          save={save}
          batchSaves={batchSaves}
          isProd={process.env.API_ENV === 'production'}
          getSkuList={getList}
          planCode={planCode}
          getMaterialList={getMaterialList}
          SwitchTab={<SwitchTab tab={switchTab} getTabData={getTabData} onChange={onChangeSwitch} showNum={false} />}
        />
      )}
    </div>
  )
})
